import { __read, __spread } from "tslib";
import { formatValue as valueFormatter } from '@keen.io/charts-utils';
import { calculatePercent } from '../../utils';
import { VALUE, PERCENTAGE_VALUE } from '../../constants';
import { MINIMAL_VALUE, TARGET_VALUE } from './constants';
export var transform = function (_a) {
    var chartSettings = _a.chartSettings;
    var data = chartSettings.data, formatValue = chartSettings.formatValue, progressType = chartSettings.progressType, minValue = chartSettings.minValue, maxValue = chartSettings.maxValue, valueKey = chartSettings.valueKey, keys = chartSettings.keys;
    var isPercentageValue = progressType === 'percent';
    var valueSelector = valueKey || keys[0];
    var columns = __spread([
        MINIMAL_VALUE,
        TARGET_VALUE,
        VALUE
    ], (isPercentageValue ? [PERCENTAGE_VALUE] : []));
    var rows = [];
    data.forEach(function (item) {
        rows.push.apply(rows, __spread(keys.map(function (keyName) { return __spread([
            minValue !== null && minValue !== void 0 ? minValue : '',
            maxValue !== null && maxValue !== void 0 ? maxValue : ''
        ], (keyName === valueSelector && __spread([
            valueFormatter(item[valueSelector], formatValue)
        ], (isPercentageValue && typeof maxValue === 'number'
            ? [calculatePercent(item[keyName], maxValue) + "%"]
            : [])))); })));
    });
    return __spread([columns], rows);
};
